import { lazy, Suspense } from 'react';
import { AceEditorProps } from './types';

export const ACE_EDITOR_ID = 'ace-editor-fallback';
const LazyAceEditor = lazy(() => import(/* webpackChunkName: "AceEditor" */ './AceEditor'));

export const AceEditor = (props: AceEditorProps) => (
  <Suspense fallback={<div data-test={ACE_EDITOR_ID} />}>
    <LazyAceEditor {...props} />
  </Suspense>
);
